<div class="field"  [ngClass]="{ 'remove-hint-space': removeHintSpace }">
    <mat-form-field
        [appearance]="appearance"
        [ngClass]="{'field-error': hasError}"
    >
        <mat-label [ngClass]="{'input-error' : hasError}">{{ label }}</mat-label>
        <input
            matInput 
            autocomplete="off"
            (focus)="touched = true"
            (blur)="checkErrors($event)"
            (keyup)="inputChanged()"
            (keyup)="keyRestrictionFunction && keyRestrictionFunction($event)"
            [type]="inputType"
            [formControl]="control"
            [placeholder]="placeholder"
            [maxLength]="maxLength"
            [mask]="mask"
            [ngClass]="{'input-error': hasError}"
        />
        <dodo-tooltip
            class="web-only"
            *ngIf="displayTooltip && tooltipText"
            iconImage="assets/img/icons/question-mark.png"
            position="top-right"
            source="mobile"
            [content]="tooltipText"
            matSuffix
        ></dodo-tooltip>
    </mat-form-field>
    <mobile-tooltip class="mobile-only" *ngIf="tooltipText" [content]="tooltipText" [withBottomSpacing]="true"></mobile-tooltip>
    <span class="error-msg" *ngIf="hasError">{{ errorMessage }}</span>
    <img *ngIf="showImage" class="validation-img" [src]="image" />
</div>